var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRequerantAddIcon = function SvgRequerantAddIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 117,
    viewBox: "0 0 520 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260,
    cy: 58.7617,
    rx: 42,
    ry: 42,
    fill: "#F9FAFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2503_10194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276 39.5618H244C241.8 39.5618 240 41.3618 240 43.5618V79.5618L248 71.5618H276C278.2 71.5618 280 69.7618 280 67.5618V43.5618C280 41.3618 278.2 39.5618 276 39.5618ZM260 57.5618C258.9 57.5618 258 56.6618 258 55.5618V47.5618C258 46.4618 258.9 45.5618 260 45.5618C261.1 45.5618 262 46.4618 262 47.5618V55.5618C262 56.6618 261.1 57.5618 260 57.5618ZM262 65.5618H258V61.5618H262V65.5618Z",
    fill: "#BDC5D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_10194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(236 34.7617)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRequerantAddIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "requerant-add-icon.e86f460f693af6596cc5b9a404e83ea2.svg";